import React from 'react';
import PropTypes from 'prop-types';
import EditorPanel from '../../../components/EditorPanel';
import MapDetailsForm from '../MapDetailsForm';

import LoadingOverlay from '../../../components/LoadingOverlay';

class MapEditPanel extends React.Component {
  constructor() {
    super();
    this.state = {
      canSubmit: false,
    };
    this.onValidSubmit = this.onValidSubmit.bind(this);
  }

  onValidSubmit(data) {
    this.props.onSubmit(data);
  }

  render() {
    const { map: { prodImage = {}, testImage = {}, units = null, offset = null } } = this.props;
    return (
      <EditorPanel title={'Map settings'} style={{ zIndex: '15', background: 'white' }}>
        <div>
          {this.props.switchDisabled && (
            <LoadingOverlay style={{ background: 'rgba(255, 255, 255, 0.85)', zIndex: 999 }} />
          )}
          <MapDetailsForm
            onValidSubmit={this.onValidSubmit}
            testImage={testImage}
            prodImage={prodImage}
            units={units}
            offset={offset}
            saveLayout={this.props.saveLayout}
            switchDisabled={this.props.switchDisabled}
          />
        </div>
      </EditorPanel>
    );
  }
}

MapEditPanel.propTypes = {
  onSubmit: PropTypes.func,
  map: PropTypes.shape(),
  switchDisabled: PropTypes.bool,
  saveLayout: PropTypes.func,
};

MapEditPanel.defaultProps = {
  onSubmit: () => {},
  map: {},
  switchDisabled: false,
  saveLayout: () => {},
};

export default MapEditPanel;



// WEBPACK FOOTER //
// ./src/components/Map/MapEditPanel/MapEditPanel.js